import { HttpClient } from "@angular/common/http";
import { BaseService } from "../../../shared/Services/BaseService";
import { authenticationService } from "../../../shared/Services/authenticationService";
import { environment } from "../../../../../environments/environment";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ContactUsMessagesService extends BaseService {

   constructor(http: HttpClient, authenticationSerives: authenticationService) {
      const baseUrl = environment.apiUrl + 'ContactUsMessages';
  
      super(http, authenticationSerives, baseUrl);
   }
 
   GetMessageStatuses(messageStatus : number) : string {
      switch (messageStatus) {
         case 0:
            return 'Pending';
         case 1:
            return 'Replied';
         default:
            return 'Pending';
      }
   }
  }


